import { render, staticRenderFns } from "./c-button.vue?vue&type=template&id=3e6ef001&scoped=true&"
import script from "./c-button.vue?vue&type=script&lang=js&"
export * from "./c-button.vue?vue&type=script&lang=js&"
import style0 from "./c-button.vue?vue&type=style&index=0&id=3e6ef001&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ef001",
  null
  
)

export default component.exports